import { enhancedApi } from '.'
import './enhancedEndpoints'
import { enhancedApi as assistantApi } from './assistant'
import './assistant/enhancedEndpoints'
import './assistantSkillScheduleEndpoints'
import { enhancedApi as billingApi } from './billing'
import { enhancedApi as chargersApi } from './chargers'
import './chargers/enhancedEndpoints'
import { enhancedApi as derSimulatorApi } from './der-simulator'
import { enhancedApi as dersApi } from './ders'
import { enhancedApi as fleetGatewayApi } from './fleet-gateway'
import { enhancedApi as fleetManagementApi } from './fleet-management'
import { publicApi } from './public'
import { enhancedApi as reportsApi } from './reports'
import { enhancedApi as ticketingApi } from './ticketing'
import './ticketing/enhancedEndpoints'
import { enhancedApi as vehicleSimulatorApi } from './vehicle-simulator'
import { enhancedApi as workflowsApi } from './workflows'

export const reducer = {
  [enhancedApi.reducerPath]: enhancedApi.reducer,
  [assistantApi.reducerPath]: assistantApi.reducer,
  [billingApi.reducerPath]: billingApi.reducer,
  [chargersApi.reducerPath]: chargersApi.reducer,
  [derSimulatorApi.reducerPath]: derSimulatorApi.reducer,
  [dersApi.reducerPath]: dersApi.reducer,
  [fleetGatewayApi.reducerPath]: fleetGatewayApi.reducer,
  [fleetManagementApi.reducerPath]: fleetManagementApi.reducer,
  [publicApi.reducerPath]: publicApi.reducer,
  [reportsApi.reducerPath]: reportsApi.reducer,
  [ticketingApi.reducerPath]: ticketingApi.reducer,
  [vehicleSimulatorApi.reducerPath]: vehicleSimulatorApi.reducer,
  [workflowsApi.reducerPath]: workflowsApi.reducer
}

export const middlewares = [
  enhancedApi.middleware,
  assistantApi.middleware,
  billingApi.middleware,
  chargersApi.middleware,
  derSimulatorApi.middleware,
  dersApi.middleware,
  fleetGatewayApi.middleware,
  fleetManagementApi.middleware,
  publicApi.middleware,
  reportsApi.middleware,
  ticketingApi.middleware,
  vehicleSimulatorApi.middleware,
  workflowsApi.middleware
]
